import React from 'react'
import { Button, Segment, Dimmer, Modal, Loader } from 'semantic-ui-react'

function AppLoader() {
  const [open, setOpen] = React.useState(true)

  return (
    <Segment className="loaderHeight">
      <Dimmer active inverted>
        <Loader size='medium'>Loading</Loader>
      </Dimmer>
    </Segment>
  )
}

export default AppLoader